import {  useEffect, useRef, useState } from "react";
import CustomTable from "../../core/custom-table";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, capitalize, IconButton, TextField, Tooltip } from "@mui/material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { ClearIcon } from "@mui/x-date-pickers";
import { toast } from "react-toastify";
import moment from "moment";
import { HTTP_METHODS, invokeApi, invokeUploadFile } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { formatDate } from "../../utils";
import { DATE_FORMATS } from "../../utils/constants";

const TrainingEnrollmentList = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {oemName,model, courseDesired, venue, courseStartDate, courseEndDate, participantsCount, dealerName, trainingMode, trainingLocation, state, address, specialTraining, courseId} =  location.state || {};
    const [filters, setFilters] = useState({
        page: 1,
        limit: 10,
        sortBy: "-serialNumber",
    });
    const [enrollmentListData, setEnrollmentListData] = useState([]);
    const fileInputRef = useRef(null);
  
    const enrollmentListConfig = {
        HeaderConfig: [
            {
              label: "S l No.",
              id: "serialNumber",
              onClick: true              
            },
            {
              label: "Name of the Organization",
              id: "oemName"
            },
            {
              label: "Name of the Candidate",
              id: "candidateName",
              render: (data) => {
                const {isError,errorMessage } = data.inValidCandidateName;
                return  <TextField
                            fullWidth
                            id="candidateName"
                            sx={{ m: 1 }}
                            onChange={onInputChange(data)}
                            value={data.candidateName}
                            size="small"
                            error={!!isError}
                            helperText={errorMessage || ''}
                        /> ;
              },
            },
            {
              label: "Age",
              id: "age",
              render: (data) => {
                const {isError,errorMessage } = data.inValidAge;
                return  <TextField
                            fullWidth
                            id="age"
                            sx={{ m: 1 }}
                            onChange={onInputChange(data)}
                            value={data.age}
                            size="small"
                            type='number'
                            error={!!isError}
                            helperText={errorMessage || ''}
                        /> ;
              },
            },
            {
              label: "Qualification",
              id: "qualification",
              render: (data) => {
                const {isError,errorMessage } = data.inValidQualification;
                return  <TextField
                            fullWidth
                            id="qualification"
                            sx={{ m: 1 }}
                            onChange={onInputChange(data)}
                            value={data.qualification}
                            size="small"
                            error={!!isError}
                            helperText={errorMessage || ''}
                        /> ;
                        },
            },
            {
              label: "No. of years Experience",
              id: "yearsOfExperience",
              render: (data) => {
                const {isError,errorMessage } = data.inValidYearsOfExperience;
                return  <TextField
                            fullWidth
                            id="yearsOfExperience"
                            sx={{ m: 1 }}
                            onChange={onInputChange(data)}
                            value={data.yearsOfExperience}
                            size="small"
                            type='number'
                            error={!!isError}
                            helperText={errorMessage || ''}
                        /> ;
              },
            },
            {
              label: "Designation",
              id: "designation",
              render: (data) => {
                const {isError,errorMessage } = data.inValidDesignation;
                return  <TextField
                            fullWidth
                            id="designation"
                            sx={{ m: 1 }}
                            onChange={onInputChange(data)}
                            value={data.designation}
                            size="small"
                            error={!!isError}
                            helperText={errorMessage || ''}
                        /> ;
                        },
            },      
            {
              label: "Course Desired",
              id: "courseDesired",
            },      
            {
                label: "Venue",
                id: "venue" ,
                render: (data) => {
                    return (
                        <>
                        {data.venue.value}
                        </>
                    )
                }       
            },
            {
                label: "Attach Participant Photograph",
                id: "candidatePhoto",
                render: (data) => {
                    return( 
                        <>                        
                        {
                            !data.candidatePhoto ?(
                            <>                            
                            <IconButton component="label">
                                <AttachFileIcon size="small"/> 
                            <input
                                id="candidatePhoto"
                                type="file"
                                hidden       
                                onChange={onInputChange(data)}       
                                ref={fileInputRef}    
                                accept="image/png, image/gif, image/jpeg"                                  
                            />                        
                            </IconButton>  
                            </>
                            ):   
                            (   
                            data.candidatePhoto && 
                            <>    
                            
                                <Box style={{'border-radius':'6px', 'width': 'fit-content', display: 'flex',alignItems: 'center',padding: '6px 8px',}}>                                
                                    <Tooltip title={data.candidatePhoto.name} arrow>
                                            <p
                                            style={{
                                                fontSize: 14,
                                                'margin-left': '8px',
                                                'margin-top': '6px',
                                                'margin-right': '10px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '200px'
                                            }}
                                            >
                                                  <img
                                                    src={data?.candidatePhoto?.url?.split('?')[0]}
                                                    alt={data?.candidatePhoto?.name}
                                                    style={{
                                                        'height': '45px',
                                                        'width': '35px',
                                                        'object-fit': 'cover' 
                                                    }}   
                                                />                                               
                                            </p>
                                        </Tooltip>
                                     <ClearIcon
                                        color='white' 
                                        sx={{ color: 'white', 'font-size':'1rem','margin-top': '1px', 'margin-right': '6px', 'margin-bottom':'6px', 'cursor':'pointer', 'padding':'4px', 'background-color':'red', 'border-radius': '20px','margin-left': '10px'}} 
                                        onClick={clearFile(data)}
                                    />
                                 </Box>
                            </>
                            )  
                        }     
                        </>                             
                    )
                }
            }   
          ]
    };
   
    const uploadFn = (data) => {
       onInputChange(data.url)
    }

    
    const validateField = (id, value) => {
        let error = {error:false, errorMessage:''};

        switch (id) {
            case 'candidateName':
                if (!value) {
                    error = {
                        errorMessage:'Candidate Name is required',
                        isError:true
                    };
                }
                break;
            case 'age':
                if (!value || isNaN(value) || value < 18 || value > 100) {
                    error = {
                        errorMessage: 'Age must be a number between 18 and 100',
                        isError:true
                    };
                }
                break;
            case 'qualification':
                if (!value) {
                    error = {
                        errorMessage :'Qualification is required',
                        isError:true
                    };
                }
                break;
            case 'yearsOfExperience':
                if (!value || isNaN(value) || value < 0) {
                    error = {
                        errorMessage :'Experience must be a positive number',
                        isError:true
                    };
                }
                break;
            case 'designation':
                if (!value) {
                    error = {
                        errorMessage : 'Designation is required',
                        isError:true
                    };
                }
                break;
            default:
                break;
        }

        return error;
    };

          
    useEffect(() => {
        const listAry = [];
        for (let i = 0; i < participantsCount; i++) {
          listAry.push({
            serialNumber: i + 1,
            oemName,
            courseDesired,
            venue,
            candidateName: '',
            age: '',
            qualification: '',
            yearsOfExperience: '',
            designation: '',
            courseDuration: '',
            candidatePhoto: '',
            inValidCandidateName: { isError: false, errorMessage: '' },
            inValidAge: { isError: false, errorMessage: '' },
            inValidQualification: { isError: false, errorMessage: '' },
            inValidYearsOfExperience: { isError: false, errorMessage: '' },
            inValidDesignation: { isError: false, errorMessage: '' },
          });
        }
        setEnrollmentListData([...listAry]);
      }, []);
      

    const clearFile = (data) => (event)=>{
        const listObj = enrollmentListData;
        setEnrollmentListData(listObj.map((objData)=>{
            if(objData.serialNumber === data.serialNumber){
                objData.candidatePhoto = null;      
                objData[`inValidCandidatePhoto`] = {};          
            };
            return objData;
        }));

        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear the input field
          }
    };

    const fileUpload = (file) => {
        const formData = new FormData();
        formData.append("upload", file);
        return invokeUploadFile(
          `${HOSTNAME}${REST_URLS.UPLOAD_FILE}${123}`,
          formData
        )
          .then((response) => {
            if (response.status === 200) {
              toast.success("Uploaded Successfully");
             return {
                url: response?.data?.url,
                name: response?.data?.originalname
             };
              //callBack && callBack(response.data);
            } else {
              toast.error(
                (response.data && response.data.message) || "Upload Failed"
              );
              //setUploadStatus("");
            }
          })
          .catch((err) => {
            //setUploadStatus("Upload Failed");
            toast.error("Upload Failed");
          });
    };
    
      const onInputChange = (data) => async (event) => {
        const { id, value } = event.target;
      
        // Handle file uploads separately
        let updatedValue = value;
        if (id === "candidatePhoto" && event.target.files[0]) {
          updatedValue = await fileUpload(event.target.files[0]);
        }
      
        // Synchronous state update
        setEnrollmentListData((prevData) =>
          prevData.map((objData) => {
            if (objData.serialNumber === data.serialNumber) {
              // Update the specific field
              objData[id] = updatedValue;
      
              // Initialize or update validation field
              objData[`inValid${capitalize(id)}`] = validateField(id, updatedValue);
            }
            return objData;
          })
        );
      };
      
   
    const submitTrainingList = () => {
        let isValid = true, createApi;
        const listObj = enrollmentListData;
        // Validate each field
        const participantsList = listObj.map((data) => {
           Object.keys(data).forEach((key) => {
                const errorObj = validateField(key, data[key]);
                if (errorObj.error) {
                    isValid = false;
                    data[`inValid${capitalize(key)}`] = {...errorObj}
                }
            });
            return data;
        });
   
    
        if (isValid) {
            // Proceed with submission
            let payload = {              
                courseName: oemName,
                trainingMode: trainingMode.value,
                numberOfParticipants: participantsCount,
                venue: venue.value,
                dealerName: dealerName,
                trainingType: specialTraining.value,
                address: {
                    line1: address,
                    city: trainingLocation,
                    state: state.label
                },
                participants: participantsList.map((data)=>{
                    return ({
                        name: data.candidateName,
                        age: data.age,
                        qualification: data.qualification,
                        experienceInYears: data.yearsOfExperience,
                        designation: data.designation,
                        photo: data.candidatePhoto.url
                    }
                    )
                })
            }
            if(courseId){
                createApi = REST_URLS.CREATE_TRAINING_SCHEDULE;
                payload = {...payload, course: courseId}
            }else{
                createApi = REST_URLS.CREATE_REQUEST_COURSE;
                payload = {
                    model,
                    courseDuration:{
                        startDate: formatDate(
                            courseStartDate,
                            DATE_FORMATS["YYYY-MM-DD"]
                          ),
                        endDate: formatDate(
                            courseEndDate,
                            DATE_FORMATS["YYYY-MM-DD"]
                          ),
                    },
                    temp:{
                        ...payload
                    }
                }
            }
            invokeApi(
                HTTP_METHODS.POST,
                `${HOSTNAME}${createApi}`,
                payload
              ).then((response) => {
                if(response.code){
                    toast.error(response.message);
                }else{
                    toast.success("Training Request Submitted Successfully");   
                    navigate('/oem/training/training-year-view')
                }
              });          
        } else {
            toast.error('Please Enter Valid Details');                      
        }
           
    };

    const cancelTrainingList = () => {
        navigate('/oem/training/training-year-view')
    };

    return(
        <>
            <div className="training-enrollment-list-container">
                <div className="title-container">
                    <span className="training-title">Training</span> 
                    <div className="list-title">Enrollment List</div>
                </div>               
                <div className="list-container">
                <CustomTable
                    header={enrollmentListConfig.HeaderConfig}
                    data={enrollmentListData || []}
                    filters={filters}
                    onChange={(page) => {
                        setFilters({
                        ...filters,
                        page,
                        });
                    }}
                    />
                </div>
               { enrollmentListData.length ?
                 <div className="button-container">
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={()=>submitTrainingList()}
                    >
                        Submit
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => {
                        cancelTrainingList();
                        }}
                    >
                        Cancel
                    </Button>                 
                </div>
                :
                ''
            }
            </div>
           
        </>
    )
};

export default TrainingEnrollmentList;